import React from "react";
import style from "./togglelist.module.css";

const TogglesList = ({ data, active, setActiveToggle }) => {
  return (
    <div style={{ position: "relative" }}>
      <div className={style.container}>
        {data?.map((item) => (
          <p
            className={active === item ? style.active : style.p}
            onClick={() => setActiveToggle(item)}
          >
            {item.toUpperCase()}
          </p>
        ))}
      </div>
      <hr
        style={{
          position: "absolute",
          bottom: "0",
          width: "90%",
          marginLeft: "2rem",
          //   marginRight: "2rem",
        }}
      />
    </div>
  );
};

export default TogglesList;
